import { render, staticRenderFns } from "./BLine.vue?vue&type=template&id=70c73b5a&scoped=true"
import script from "./BLine.vue?vue&type=script&lang=js"
export * from "./BLine.vue?vue&type=script&lang=js"
import style0 from "./BLine.vue?vue&type=style&index=0&id=70c73b5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c73b5a",
  null
  
)

export default component.exports